import React, { KeyboardEvent } from 'react';
import Box from '@mui/material/Box';
import BentoIcon from './BentoIcon';

// Define the props type
interface HeaderActionProps {
  id?: string;
  iconName: string;
  label: string;
  onClick?: () => void;
  selected?: boolean;
}

export default function HeaderAction({
  id,
  iconName,
  label,
  onClick,
  selected = false,
  ...other
}: HeaderActionProps) {
  return (
    <Box
      id={id}
      onKeyDown={(e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
          onClick?.();
        }
      }}
      onClick={onClick}
      role="button"
      tabIndex={0}
      fontWeight={selected ? '600' : 'inherit'}
      color={selected ? '#42806f' : 'inherit'}
      sx={{
        cursor: 'pointer',
        pointerEvents: 'auto', // Provides pointer events to parent (see HeaderActionList)
      }}
      {...other}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <BentoIcon name={iconName} fontSize="inherit" />
        <Box display={{ xs: 'none', md: 'inline' }}>{label}</Box>
      </Box>
    </Box>
  );
}
